import moment from "moment"
import { push } from 'connected-react-router';
import { actionCreators as routeDivisionActions } from 'react/api/actions/routeDivisionModal';

class RouteRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "Route";
    const model = App.Models.Route;
    const collectionClass = App.Collections.Routes;

    super(entityName, model, collectionClass);
  }

  onValidate = () => {
    this.validateRouteDate();
    this.validateDestinationInfo();
  };

  afterCreateForm = () => {

    if (Monet.Session.Route.isAddingStop || Monet.Session.Route.stopEditingId) {
      const routeScreen = document.getElementById("Route");
      if (routeScreen) {
        routeScreen.style.display = "none";
      }
    }

    var routeView = App.Views.Route;
    routeView.addEventListenners();
    routeView.setDefaultDateToPlanned();

    this.updateBodyRequestLocation();
    this.setButtonsListeners();
  };

  setButtonsListeners = () => {
    const btnExitSelector = `#${this.entityName} #form_and_grid #Route_btn_exit`;
    const onRemoveTreeView = () => {
      Monet.Session.TreeviewRoute = {};
    };
    const btnExitCallback = () => {
      this.removeTreeView(
        '#Route #form_and_grid #treeViewForm',
        onRemoveTreeView
      );
    };

    this.onExit({
      selector: btnExitSelector,
      onClick: btnExitCallback
    });
  };

  updateBodyRequestLocation = () => {
    var defaultCriteriaForFields = {
      criteriaChain: [
        {
          and: [{ attr: "enabled", eq: true }]
        }
      ]
    };

    App.Forms.Route.form.fields.origin.setRequestBody(defaultCriteriaForFields);

    App.Forms.Route.form.fields.destination.setRequestBody(
      defaultCriteriaForFields
    );
  };

  afterPopulateForm = model => {
    const routeId = this.editModelId;

    if (routeId) {
      if (model.attributes.lastStopIsDestination) {
        var destinationField = App.Forms.Route.form.fields.destination;
        destinationField.disable();
      }

      this.createTreeview(model);

      if (this.routeIsArriveDestination() || this.routeIsFinished()) {
        this.disableButtonsToRouteFinished();
      }
      var btns = [];

      if (model.attributes.status === "COMPLETED") {
        var btns = App.Forms.Route.form.buttons.btn_show_assign_driver_to_route;
        for (var i in btns) {
          btns[i].input.setAttribute("disabled", "disabled");
        }
      } else {
        App.Views.Route.addChangeOrganizationButton();
      }

      const hasHelperCheckbox = document.querySelector("#hasHelper");
      if (hasHelperCheckbox) {
        hasHelperCheckbox.disabled = true;

        const success = helpers => {
          if (helpers && helpers.length > 0) {
            hasHelperCheckbox.checked = true;
            hasHelperCheckbox.disabled = true;
          } else {
            hasHelperCheckbox.disabled = false;
          }
        };

        this.getHelpersByRoute(routeId, success);
      }
    }

    if (Monet.Session.Route.isAddingStop) {
      Monet.Session.Route.isAddingStop = false;
      this.addStop();
    } else if (Monet.Session.Route.stopEditingId) {
      const stopId = Monet.Session.Route.stopEditingId;
      Monet.Session.Route.stopEditingId = null;

      const form = App.Forms.Route.form;
      const routeId = form.fields.id.getValue();

      this.openEditStop(routeId, stopId);
    }

    if (this.crudStage === 'edit' && model.attributes.status === "COMPLETED") {
      App.Forms.Route.form.buttons.btn_to_route_monitor.forEach(item => item.input.setAttribute('disabled', 'true'));
    }
  };

  beforeCreateForm = (_entity, layout, crudStage) => {
    if(crudStage === 'edit') {
      this.addRedirectButtons(layout);
    }
  };

  addNewSectionButton = (sectionIndex, button) => {
    App
      .Forms
      .Route
      .layout
      .edit
      .sections[sectionIndex]
      .sectionButtons
      .splice(1, 0, button);
  };

  addRedirectButtons = (layout) => {
    const sectionTopBottomIndex = 0;
    const sectionsTopBotomButtons =
      App.Forms.Route.layout.edit.sections[sectionTopBottomIndex];

    const hasRouteDetailButton =
      sectionsTopBotomButtons.sectionButtons
        .find(button => button.name === "btn_to_route_details");

    if(!hasRouteDetailButton) {
      const routeDetailButton = {
        buttonOrder: 8,
        customJavaScript: "App.Objects.Route.goToRouteDetail();",
        customLabel: "topMenu.routeDetail",
        name: "btn_to_route_details",
        type: "SectionButton",
        pageLayoutSection: {
          id: layout.sections[sectionTopBottomIndex].id
        }
      };

      this.addNewSectionButton(sectionTopBottomIndex, routeDetailButton);
    }

    const hasRouteMonitorButton =
        sectionsTopBotomButtons.sectionButtons
          .find(button => button.name === "btn_to_route_monitor");

    if(!hasRouteMonitorButton) {
      const routeMonitorButton = {
        buttonOrder: 8,
        customJavaScript: "App.Objects.Route.goToRouteMonitor();",
        customLabel: "RouteMonitor",
        name: "btn_to_route_monitor",
        type: "SectionButton",
        pageLayoutSection: {
          id: layout.sections[sectionTopBottomIndex].id
        }
      };

      this.addNewSectionButton(sectionTopBottomIndex, routeMonitorButton);
    }
  };

  addMenuToGrid = () => {

    var enabledMenus = Monet.Grid.Utils.getMenusEnabledFromGridLayout(
      App.Forms.Route.layout.index
    );

    var optionsMenu = {
      targetEl: "#Route .gridContainer",
      description: "description",
      addListenerToParent: false
    };

    var menu = new Greenmile.Route.Menu();

    menu.setOptionsMenu(optionsMenu);
    menu.setEnabledMenus(enabledMenus);

    var grid = App.Forms.Route.table;

    var removeMenu = (function(context) {
      return function() {
        if (context.gridMenu) {
          context.gridMenu.removeAllMenus();
        }
      };
    })(menu);

    var showMenu = (function(context) {
      return function(e, args) {
        context.showMenuToRowSelected(e, args);
      };
    })(menu);

    grid.onClick.unsubscribe(showMenu);
    grid.onClick.subscribe(showMenu);

    grid.onScroll.unsubscribe(removeMenu);
    grid.onScroll.subscribe(removeMenu);
  };

  addRouteDivisionButtonListener = () => {
    const routeDivisionBtn = document.getElementById('Route_btn_route_division');

    if(!routeDivisionBtn) {
      return;
    }

    routeDivisionBtn.addEventListener("click", () => {
      window.GreenmileReduxStore.dispatch(routeDivisionActions.openModal())
    });
  };

  addRouteDivisionButtonListener = () => {
    const routeDivisionBtn = document.getElementById('Route_btn_route_division');

    if(!routeDivisionBtn) {
      return;
    }

    routeDivisionBtn.addEventListener("click", () => {
      window.GreenmileReduxStore.dispatch(routeDivisionActions.openModal())
    });
  };

  goToRouteDetail = () => {
    const routeId = this.editModelId;

    const path = `/maps/route/${routeId}/details`;

    window.GreenmileReduxStore.dispatch(push(path));
  };

  goToRouteMonitor = () => {
    const routeModel = App.Forms.Route.form.model;
    const { organization, key, date } = routeModel.attributes;
    const organizationId = organization.id;

    const params = new URLSearchParams({
      startDate: moment(date).subtract(1, 'months').format('YYYY-MM-DD'),
      endDate: moment(date).add(1, 'months').format('YYYY-MM-DD'),
      organizationId,
      queryParameter: key,
    });

    const path = `/RouteMonitor?${params.toString()}`;

    window.GreenmileReduxStore.dispatch(push(path));
  };

  checkRouteDivisionPermission = () => {
    const routeDivisionBtn = document.getElementById('Route_btn_route_division');
    const { permissions } = Monet.Session.Security;
    const hasPermission = permissions.some(permission => {
      const permissionToTransferOrders = 'ROUTE_ORDERS_TRANSFERENCE';

      return permission.key = permissionToTransferOrders;
    });

    if(!routeDivisionBtn || hasPermission) {
      return;
    }

    routeDivisionBtn.style.display = 'none';
  }

  beforeList = () => {
    App.Forms.Route.filterBuilder.changeCriteriaBeforeFilter = function(
      criteria
    ) {
      const hasEquipmentDefault = criteria.criteriaChain[0].and.some(
        condition => {
          return condition.attr === "equipmentAssignments.equipment.id";
        }
      );

      if (hasEquipmentDefault) {
        const newCriteria = {
          eq: true,
          attr: "equipmentAssignments.principal"
        };
        criteria["criteriaChain"][0]["and"].push(newCriteria);
      }
      return criteria;
    };

    this.addMenuToGrid();
    this.checkRouteDivisionPermission();
    this.addRouteDivisionButtonListener();
  };

  saveAndClose = () => {
    this.create();
  };

  saveAndAddStop = () => {
    const callbackAfterRequest = (data) => {
      const routeId = data.attributes.id;
      const form = App.Forms.Route.form;

      form.setEntityId(routeId);
      form.setModel(data);
      this.addStop();

      if(form.crudStage === "new") {
        this.createTreeview(data);
      }
    };

    this.create(callbackAfterRequest);
  };

  goToEditRoute = routeId => {
    if (App.Forms.Route) {
      App.Forms.Route.form.setEntityId(routeId);
    }

    var url = "#/Route/edit/" + routeId;
    window.location.href = url;
  };

  addStop = () => {
    var form = App.Forms.Route.form;
    var routeId = form.fields.id.getValue();

    if (routeId) {
      var url = "#/Route/" + routeId + "/Stop/new";
      window.location.href = url;
    }
  };

  validateDestinationInfo = () => {
    var formFields = App.Forms.Route.form.fields;
    var destination = formFields.destination;
    var lastStopIsDestination = formFields.lastStopIsDestination;

    var classes = "control-group";

    if (!lastStopIsDestination.getValue() && !destination.getValue()) {
      classes += " error";
      destination.rootEl.setAttribute("class", classes);

      this.allow_submit.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          "route.messageError.destination"
        )
      );
      this.allow_submit.status = false;
    } else {
      classes += classes.replace(/error/g, "");
      destination.rootEl.setAttribute("class", classes);
    }
  };

  validateRouteDate = () => {
    var fields = App.Forms.Route.form.fields;

    var plannedDeparture = fields.plannedDeparture;
    var plannedArrival = fields.plannedArrival;
    var plannedStart = fields.plannedStart;
    var plannedComplete = fields.plannedComplete;
    var routeDate = fields.date;
    var dateFunctions = new Monet.Date.GeneralFunctions();
    var haveError = 0;

    var startValue = plannedStart.getValue(),
        completeValue = plannedComplete.getValue(),
        departureValue = plannedDeparture.getValue(),
        arrivalValue = plannedArrival.getValue(),
        routeDateValue = routeDate.getValue();

    var labelComplete = plannedComplete.rootEl,
      labelDeparture = plannedDeparture.rootEl,
      labelArrival = plannedArrival.rootEl;

    var completeIsOk = function() {
      var isGreaterStart = dateFunctions.validateDateGreaterOrEqualThan(
          startValue,
          completeValue
        ),
        isGreaterDeparture = dateFunctions.validateDateGreaterOrEqualThan(
          departureValue,
          completeValue
        ),
        isGreaterOrEqualsArrival = dateFunctions.validateDateGreaterOrEqualThan(
          arrivalValue,
          completeValue
        );

      if (isGreaterStart && isGreaterDeparture && isGreaterOrEqualsArrival) {
        return true;
      }

      return false;
    };

    var completeIsGreaterThanRouteDate = function() {
      return dateFunctions.validateDateGreaterOrEqualThan(
        routeDateValue,
        completeValue
      );
    };

    var arrivalIsOk = function() {
      var isGreatherStart = dateFunctions.validateDateGreaterOrEqualThan(
          startValue,
          arrivalValue
        ),
        isGreatherDeparture = dateFunctions.validateDateGreaterOrEqualThan(
          departureValue,
          arrivalValue
        );

      if (isGreatherStart && isGreatherDeparture) {
        return true;
      }

      return false;
    };

    var arrivalIsGreaterThanRouteDate = function() {
      return dateFunctions.validateDateGreaterOrEqualThan(
        routeDateValue,
        arrivalValue
      );
    };

    var departureIsOk = function() {
      return dateFunctions.validateDateGreaterOrEqualThan(
        startValue,
        departureValue
      );
    };

    if (completeIsOk() && completeIsGreaterThanRouteDate()) {
      labelComplete.setAttribute("class", "control-group");
    } else {
      labelComplete.setAttribute("class", "control-group error");

      this.allow_submit.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          "route.messageError.plannedComplete"
        )
      );

      haveError++;
    }

    if (arrivalIsOk() && arrivalIsGreaterThanRouteDate()) {
      labelArrival.setAttribute("class", "control-group");
    } else {
      labelArrival.setAttribute("class", "control-group error");

      this.allow_submit.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          "route.messageError.plannedArrival"
        )
      );

      haveError++;
    }

    if (departureIsOk()) {
      labelDeparture.setAttribute("class", "control-group");
    } else {
      labelDeparture.setAttribute("class", "control-group error");

      this.allow_submit.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          "route.messageError.plannedDeparture"
        )
      );

      haveError++;
    }

    if (haveError > 0) {
      this.allow_submit.status = false;
    }
  };

  beforeValidate = () => {
    App.Forms.Route.form.setFakeField(
      "status",
      App.Forms.Route.form.getModel().get("status")
    );
  };

  updateWithoutClose = () => {
    this.update(function(data) {
      if (data) {
        var monetMessage = new Monet.Form.Messages.InlineMessage();
        monetMessage.setScope("#Route");
        monetMessage.setInfoType("success");
        monetMessage.setMessage(Monet.I18n.getResourcesByKey('route.feedback.updated'));
        monetMessage.triggerMessage();
      }
    });
  };

  updateAndAddStop = () => {
    var callbackAfterRequest = function(data) {
      if (typeof data !== "undefined") {
        var url = "#/Route/" + data.id + "/Stop/new";
        window.location.href = url;
      }
    };

    this.update(callbackAfterRequest);
  };

  createTreeview = async routeModel => {
    const route = routeModel?.attributes;
    if (route) {
      Monet.Session = Monet.Session || {};
      Monet.Session.TreeviewRoute = Monet.Session.TreeviewRoute || {};
      Monet.Session.TreeviewRoute[route.id] = await this.getValuesToNamespace(
        routeModel      );
      var routeView = App.Views.Route;
      var nodes = Monet.Session.TreeviewRoute[route.id].treeviewNodes;
      routeView.adjustFormAndShowTreeview(nodes);
      $("#Route #treeViewForm #routeTreeview ul li").on("click", function(
        event      ) {
        event.stopPropagation();
      });
    }
  };

  getValuesToNamespace = async routeModel => {
    var routeModelIsUndefined = typeof routeModel === "undefined",
      routeModelIsNull = typeof routeModel === "null";

    if (routeModelIsUndefined || routeModelIsNull) {
      return {
        stops: [],
        treeviewNodes: []
      };
    }

    var parentNode = [];

    if (typeof routeModel.attributes === "undefined") {
      routeModel = new App.Models.Route({
        id: routeModel
      });
      routeModel.fetchWithCriteria({
        criteria: '{"filters":["key","actualComplete"]}',
        success: function() {}
      });
    }

    var routeId = routeModel.attributes.id;
    var key = routeModel.attributes.key;

    parentNode[0] = {
      attr: {
        id: routeId,
        action:
          "new App.Routers.Route().goToEditRouteInTreeview(" + routeId + ")"
      },
      data: key,
      state: "open"
    };

    var stops = await this.getStopsByRoute(routeModel.id);
    parentNode[0].children = this.getNodesChildrenToRouteTreeview(
      routeModel.id,
      stops
    );

    var namespaceValues = {
      route: routeModel,
      stops: stops,
      treeviewNodes: parentNode
    };

    return namespaceValues;
  };

  getStopsByRoute = async routeId => {
    const stops = new App.Collections.Stops();

    await stops.filterWithCriteria({
      filter: {
        criteriaChain:[
          {
            and: [
              {
                attr: "route.id",
                eq: routeId
              }
            ]
          }
        ],
        sort: [
          {
            attr: "plannedSequenceNum",
            type: "ASC"
          }
        ]
     },
      criteria:
        '{"filters":["*", "location.*", "stopType.*", "route.id", "route.actualComplete", "route.actualArrival", "cancelCode.*"]}',
      success: function() {}
    });

    return stops;
  };

  getNodesChildrenToRouteTreeview = (routeId, stopCollection) => {
    var nodes = [];
    var stopRouter = new App.Routers.Stop();

    stopCollection.models.forEach(stop => {
      nodes.push(stopRouter.formatNodeStopToTreeview(routeId, stop));
    });

    return nodes;
  };

  openEditStop = (routeId, stopId, event) => {
    event && event.stopPropagation();

    const path = `/Route/${routeId}/Stop/edit/${stopId}`;

    window.GreenmileReduxStore.dispatch(push(path));
  };

  goToEditRouteInTreeview = routeId => {
    const isInFormRoute = document.querySelector("#Route form.MonetUIForm.Route") !== null;

    if (!isInFormRoute) {
      new Greenmile.Components.AlertModal("greenmile.message.exitOnScreen",
        null,
        () => {
          const path = `/Route/edit/${routeId}`;

          window.GreenmileReduxStore.dispatch(push(path))
        }
      ).show();
    }
  };

  /**
   * Métodos para a funcionalidade assignDriver
   *
   */

  doAjax = async params => {
    var ajax = new Monet.Ajax();
    ajax.url = params.url;
    ajax.method = params.method || "post";
    ajax.data = params.data;
    ajax.success = params.success;
    ajax.error = params.error;

    await ajax.send();
  };

  getRouteStatus = (successCallback, errorCallback) => {
    const routeId = App.Forms.Route.form.fields.id.getValue();
    let routeStatus = "";

    try {
      this.doAjax({
        url: 'Route/restrictions?criteria={"filters" : ["status"]}',
        data: {
          criteriaChain: [
            {
              and: [
                {
                  attr: "id",
                  eq: routeId
                }
              ]
            }
          ]
         },
        success: function(data) {
          routeStatus = data[0].status;
          if (successCallback) {
            successCallback(routeStatus);
          }
        },
        error: function(data) {
          const error = new Monet.Exception.ReturnError(
            this,
            "Couldn't get current route status."
          );
          error.console();

          if (errorCallback) {
            errorCallback(data);
          }
        }
      });
    } catch (e) {
      const error = new Monet.Exception.ReturnError(
        this,
        "Couldn't get current route status."
      );
      error.console();
    }

    return routeStatus;
  };

  assignHelperToRoute = () => {
    var assignHelper = new Greenmile.Route.AssignHelper();
    const hasHelperCheckbox = document.querySelector("#hasHelper");
    if (assignHelper.validateForm()) {
      const validateSuccess = isValid => {
        if (isValid) {
          var selectorDrivers =
              "#form_assign_helper #driver_list input[type='hidden']",
            routeId = App.Forms.Route.form.fields.id.getValue(),
            drivers = document.querySelectorAll(selectorDrivers),
            totalDrivers = drivers.length,
            model = new App.Models.RouteHelperAssignment();

          for (var i = 0; i < totalDrivers; i++) {
            var driver = drivers[i];

            var data = {
              route: {
                id: routeId
              },
              helper: {
                id: driver.value
              }
            };

            model.assignToRoute(
              { list: data },
              (function(closeModalWindow) {
                if (closeModalWindow) {
                  //in this case, some helpers were selected then hasHelper checkbox is unchecked
                  hasHelperCheckbox.checked = true;
                  hasHelperCheckbox.disabled = true;
                  assignHelper.modalForm.closeModalWindow();
                }
              })(i == totalDrivers - 1)
            );
          }
        }
      };

      assignHelper.validateRouteStatus(validateSuccess);
    } else {
      assignHelper.modalForm.closeModalWindow();
      //in this case, there are no helpers selected
      if (hasHelperCheckbox.disabled) {
        hasHelperCheckbox.disabled = false;
        hasHelperCheckbox.checked = false;
      }
    }
  };

  getDriversByRoute = async routeId => {
    var drivers = [],
      error = null;

    if (routeId) {
      try {
        await this.doAjax({
          url:
            'RouteDriver/restrictions?criteria={"filters" : ["*","driver.name", "driver.id"]}',
          data: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "route.id",
                    eq: routeId
                  }
                ]
              }
            ]
          },
          success: function(data) {
            drivers = data;
          }
        });
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "No route to get drivers.",
          e
        );
        error.console();
      }
    } else {
      error = new Monet.Exception.ReturnError(this, "No data to save drive.");
      error.console();
    }

    return drivers;
  };

  getHelpersByRoute = (routeId, successCallback, errorCallback) => {
    var helpers = [],
      error = null;

    if (routeId !== null || typeof routeId !== "undefined") {
      try {
        this.doAjax({
          url:
            'RouteHelper/restrictions?criteria={"filters" : ["*","helper.name", "helper.id"]}',
          data: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "route.id",
                    eq: routeId
                  }
                ]
              }
            ]
          },
          success: function(data) {
            helpers = data;
            if (successCallback) {
              successCallback(data);
            }
          },
          error: function(data) {
            if (errorCallback) {
              errorCallback(data);
            }
          }
        });
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "No route to get drivers."
        );
        error.console();
      }
    } else {
      error = new Monet.Exception.ReturnError(this, "No data to save drive.");
      error.console();
    }

    return helpers;
  };

  getEquipmentsByRoute = async (options, successCallback, errorCallback) => {
    var equipments = [],
      error = null,
      routeId = options.routeId;

    if (routeId) {
      try {
        await this.doAjax({
          url:
            'RouteEquipment/restrictions?criteria={"filters" : ["*","equipment.key", "equipment.description", "equipment.id", "equipment.equipmentType.*"]}',
          data: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "route.id",
                    eq: routeId
                  }
                ]
              }
            ]
          },
          success: function(data) {
            equipments = data;

            if (successCallback) {
              successCallback(data);
            }
          },
          error: function(data) {
            if (errorCallback) {
              errorCallback(data);
            }
          }
        });
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "No route to get drivers.",
          e
        );
        error.console();
      }
    } else {
      error = new Monet.Exception.ReturnError(this, "No data to save drive.");
      error.console();
    }

    return equipments;
  };

  getTagsByRoute = async routeId => {
    let tags = [],
    error = null;

    if (routeId !== null || typeof routeId !== "undefined") {
      try {
        await this.doAjax({
          url:
            'RouteTag/restrictions?criteria={"filters" : ["*","tag.description", "tag.id", "tag.tagType"]}',
          data: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "route.id",
                    eq: routeId
                  }
                ]
              }
            ]
          },
          success: function(data) {
            tags = data;
          }
        });
      } catch (e) {
        error = new Monet.Exception.ReturnError(this, "No route to get tags.");
        error.console();
      }
    } else {
      error = new Monet.Exception.ReturnError(this, "No data to save tag.");
      error.console();
    }

    return tags;
  };

  /**
   * Fim do métodos da funcionalidade assignTag
   */

  routeIsFinished = () => {
    var actualComplete = App.Forms.Route.form.fields.actualComplete.getValue();
    return actualComplete ? true : false;
  };

  /**
   * Cerificacao caso o actual arrive nao seja null.
   */
  routeIsArriveDestination = () => {
    var arriveDestination = App.Forms.Route.form.fields.actualArrival.getValue();
    return arriveDestination ? true : false;
  };

  beforePopulateLocalCollection = () => {
    var projection = JSON.parse(this.projection);
    projection.filters = projection.filters.concat("status");
    this.projection = JSON.stringify(projection);
  };

  disableButtonsToRouteFinished = () => {
    let buttons = App.Forms.Route.form.buttons;

    const allowedButtons = [
      "btn_exit",
      "btn_show_assign_tag_to_route",
      "btn_to_route_details",
      "btn_to_route_monitor"
    ];

    for (let i in buttons) {
      if (!allowedButtons.includes(i)) {
        buttons[i].forEach((btn) => {
          btn.input.setAttribute("disabled", "disabled");
        });
      }
    }
  };

  updateRouteOrganization = (routeId, organizationId, successCallback, errorCallback) => {
    const loading = new Monet.UI.LoadingData();
    const ajax = new Monet.Ajax({
      url: `/Route/${routeId}/UpdateRouteOrganization`,
      method: "POST",
      data: { id: organizationId }
    });

    loading.init();
    loading.show();

    ajax.success = () => {
      loading.hide();
      successCallback && successCallback();
    };

    ajax.error = function(response) {
      loading.hide();
      Monet.Configurations.errorNotification(null, response);
      errorCallback && errorCallback();
    };

    ajax.send();
  };
}

App.Routers.Route = RouteRouter;
